import { ethers } from 'ethers';

// Format a BigNumber (18 decimals) to a readable USD string
export function formatUSDT(value, decimals = 2) {
  if (!value) return '0.00';
  try {
    const formatted = ethers.utils.formatUnits(value, 18);
    const num = parseFloat(formatted);
    return num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  } catch {
    return '0.00';
  }
}

// Format XT amount
export function formatXT(value, decimals = 4) {
  if (!value) return '0.0000';
  try {
    const formatted = ethers.utils.formatUnits(value, 18);
    const num = parseFloat(formatted);
    return num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  } catch {
    return '0.0000';
  }
}

// Parse user input string to BigNumber (18 decimals)
export function parseUSDT(str) {
  if (!str || str === '') return ethers.BigNumber.from(0);
  try {
    return ethers.utils.parseUnits(str.toString(), 18);
  } catch {
    return ethers.BigNumber.from(0);
  }
}

// Shorten an address: 0x1234...ABCD
export function shortenAddress(address, chars = 4) {
  if (!address) return '';
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`;
}

// Convert unix timestamp to readable date/time
export function formatDate(ts) {
  if (!ts || Number(ts) === 0) return '—';
  const d = new Date(Number(ts) * 1000);
  return d.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Countdown from now to a target unix timestamp
export function formatCountdown(targetTs) {
  const now = Math.floor(Date.now() / 1000);
  const diff = Number(targetTs) - now;
  if (diff <= 0) return 'Ready';
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

// Basis points to percentage string
export function bpsToPercent(bps) {
  return `${(Number(bps) / 100).toFixed(2)}%`;
}
